import React, { useState, useEffect } from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFDownloadLink,
  Image,
  BlobProvider,
  Svg,
  Path,
  Font,
} from "@react-pdf/renderer";
import axios from "axios";
import { getToken } from "../../auth/authConfig";
import MarsLogo from "../../../assets/img/Mars_icon_white.png";
import MarsLogo1 from "../../../assets/img/pdfLogo.png";
import { FaFileDownload } from "react-icons/fa";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { Box, Alert } from "@mui/material";
import { login } from "../../auth/msalAuth";

const styles1 = {
  table: { display: "table", width: "100%", borderCollapse: "collapse" },
  row: { flexDirection: "row", justifyContent: "center", alignItems: "center" },
  headerCell: {
    backgroundColor: "#000066",
    color: "white",
    fontSize: 7,
    fontWeight: "bold",
    padding: 5,
    textAlign: "center",
    border: "1px solid white",
  },
  cell: {
    fontSize: 7,
    padding: 5,
    textAlign: "center",
  },
  compliant: {
    backgroundColor: "#C5E17A",
    fontWeight: "bold",
    border: "1px solid white",
  },
  needsImprovement: {
    backgroundColor: "#F8CE6A",
    fontWeight: "bold",
    border: "1px solid white",
  },
  atRisk: {
    backgroundColor: "#E84B3C",
    fontWeight: "bold",
    border: "1px solid white",
  },
  darkHeader: {
    backgroundColor: "#232F7E",
    color: "white",
    border: "1px solid white",
  },
  factoriesValue: {
    color: "blue",
    fontWeight: "bold",
    border: "1px solid white",
  },
  bulletPointContainer: {
    flexDirection: "row",
    marginBottom: 3,
  },
  bulletPoint: {
    width: 10,
    fontSize: 7,
  },
  bulletText: {
    fontSize: 7,
    width: "95%",
  },
};

const styles = StyleSheet.create({
  page: { padding: 20 },
  section: { marginBottom: 10 },
  header: { fontSize: 18, fontWeight: "bold", marginBottom: 5 },
  text: { fontSize: 7 },
  footer: {
    position: "absolute",
    bottom: 3,
    right: 20,
    textAlign: "center",
    fontSize: 7,
    color: "gray",
  },
});

const styles2 = StyleSheet.create({
  pageBreak: { break: "before" },
});

const formatDate = (dateString) => {
  if (!dateString) return "N/A"; // Handle null or undefined values

  const date = new Date(dateString);
  if (isNaN(date)) return "N/A"; // Handle invalid date strings

  const day = date.getDate();
  const month = date.toLocaleString("en-US", { month: "long" });
  const year = date.getFullYear();

  // Function to add ordinal suffix (st, nd, rd, th)
  const getOrdinal = (num) => {
    if (num > 3 && num < 21) return "th"; // Covers 11th to 20th
    switch (num % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  return `${day}${getOrdinal(day)} ${month} ${year}`;
};

const AuditPDF = ({ auditData }) => (
  <Document>
    <Page size="A4" style={{ padding: 20, paddingBottom: 35 }} wrap>
      <>
        <View
          style={{
            backgroundColor: "#0000a0",
            height: "100%",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          {/* Background color block */}
          <View>
            {/* Centered Image */}
            <Image src={MarsLogo} style={{ width: 300, marginTop: 100 }} />
          </View>

          <View>
            {/* Centered Image */}
            <Text style={{ color: "white", fontSize: "24px" }}>
              {auditData?.unitIndex}
            </Text>
          </View>

          <View>
            {/* Centered Image */}

            <Text
              style={{
                color: "white",
                fontSize: "22px",
                textAlign: "center",
                paddingTop: "10px",
              }}
            >
              Audit # - {auditData?.formId}
            </Text>
          </View>

          <View>
            {/* Centered Image */}

            <Text
              style={{
                color: "white",
                fontSize: "22px",
                textAlign: "center",
                paddingTop: "10px",
              }}
            >
              Version -{" "}
              {auditData?.version === "V1"
                ? "1"
                : auditData?.version === "V2"
                  ? "2"
                  : "2"}
            </Text>
          </View>

          <View
            style={{
              backgroundColor: "#6CC9FF",
              height: 100,
              margin: 20,
              alignContent: "center",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* Centered Image */}
            <Text
              style={{
                color: "white",
                fontSize: "20px",
                margin: 10,
                alignContent: "center",
                alignItems: "center",
                textTransform: "capitalize",
              }}
            >
              MARS QMS {auditData?.auditType} Unit Audit
            </Text>
            <Text
              style={{
                color: "white",
                fontSize: "20px",
                margin: 5,
                alignContent: "center",
                alignItems: "center",
              }}
            >
              {formatDate(auditData?.endDate)}
            </Text>
          </View>

          <View>
            {/* Centered Image */}
            <Image src={MarsLogo1} style={{ width: 300, marginTop: 10 }} />
          </View>
        </View>
        <View style={styles.footer} fixed>
          <Text style={{ textTransform: "capitalize" }}>
            {auditData?.unitIndex}, {auditData?.auditType},{" "}
            {formatDate(auditData?.endDate)}{" "}
          </Text>
        </View>
        <View
          style={{
            height: "100%",
            // minHeight:"100%",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          {/* Executive Summary*/}
          <View>
            <View style={{ alignItems: "center", marginBottom: 20 }}>
              <Text
                style={{
                  fontSize: 14,
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                Executive Summary
              </Text>
            </View>

            {/* QMS Results Table */}
            <View
              style={{
                border: "1px solid black",
                width: "100%",
                marginBottom: 20,
              }}
            >
              {auditData &&
                auditData["scoringDetails"] &&
                auditData["scoringDetails"]["executiveSummaryResult"] &&
                auditData["scoringDetails"]["executiveSummaryResult"].length !==
                0 && (
                  <View
                    style={{
                      flexDirection: "row",
                      backgroundColor: "#0000a0",
                    }}
                  >
                    <Text
                      style={{
                        color: "white",
                        width: "30%",
                        borderRight: "1px solid white",
                        fontSize: 7,
                        padding: 5,
                      }}
                    >
                      QMS Results
                    </Text>
                    <Text
                      style={{
                        color: "white",
                        width: "30%",
                        borderRight: "1px solid white",
                        fontSize: 7,
                        padding: 5,
                      }}
                    >
                      Number of Nonconformances
                    </Text>
                    <Text
                      style={{
                        color: "white",
                        width: "40%",
                        fontSize: 7,
                        padding: 5,
                      }}
                    >
                      Nonconformance Points
                    </Text>
                  </View>
                )}

              {/* Table Rows */}
              {auditData &&
                auditData["scoringDetails"] &&
                auditData["scoringDetails"]["executiveSummaryResult"] &&
                auditData["scoringDetails"]["executiveSummaryResult"].length !==
                0 &&
                auditData["scoringDetails"]["executiveSummaryResult"].map(
                  (row, index) => (
                    <View
                      key={index}
                      style={{
                        flexDirection: "row",
                        borderBottom:
                          index !==
                            (auditData &&
                              auditData["scoringDetails"] &&
                              auditData["scoringDetails"] &&
                              auditData["scoringDetails"][
                                "executiveSummaryResult"
                              ].length - 1)
                            ? "1px solid black"
                            : "none", // Last row should not have a border
                      }}
                    >
                      <Text
                        style={{
                          width: "30%",
                          fontSize: 7,
                          textAlign: "left",
                          borderRight: "1px solid black",
                          padding: 5,
                        }}
                      >
                        {row.category}
                      </Text>
                      <Text
                        style={{
                          width: "30%",
                          fontSize: 7,
                          textAlign: "left",
                          borderRight: "1px solid black",
                          padding: 5,
                        }}
                      >
                        {row.noOfNonCon}
                      </Text>

                      <Text style={{ width: "40%", fontSize: 7, padding: 5 }}>
                        {row.nonConPoints}
                      </Text>
                    </View>
                  )
                )}
            </View>
          </View>

          {/* FSSC Summary*/}
          <View>
            {/* QMS Results Table */}
            <View
              style={{
                border:
                  auditData["scoringDetails"] &&
                    auditData["scoringDetails"][
                    "executiveSummaryCertification"
                    ] &&
                    auditData["scoringDetails"]["executiveSummaryCertification"]
                      .length !== 0
                    ? "1px solid black"
                    : "",
                width: "100%",
                marginBottom:
                  auditData["scoringDetails"] &&
                    auditData["scoringDetails"][
                    "executiveSummaryCertification"
                    ] &&
                    auditData["scoringDetails"]["executiveSummaryCertification"]
                      .length !== 0
                    ? 20
                    : 0,
              }}
            >
              {/* Table Header */}
              {auditData &&
                auditData["scoringDetails"] &&
                auditData["scoringDetails"]["executiveSummaryCertification"] &&
                auditData["scoringDetails"]["executiveSummaryCertification"]
                  .length !== 0 && (
                  <View
                    style={{
                      flexDirection: "row",
                      backgroundColor: "#0000a0",
                    }}
                  >
                    <Text
                      style={{
                        color: "white",
                        width: "30%",
                        borderRight: "1px solid white",
                        fontSize: 7,
                        padding: 5,
                      }}
                    >
                      FSSC Certification Results
                    </Text>
                    <Text
                      style={{
                        color: "white",
                        width: "30%",
                        borderRight: "1px solid white",
                        fontSize: 7,
                        padding: 5,
                      }}
                    >
                      Number of Nonconformances
                    </Text>
                    <Text
                      style={{
                        color: "white",
                        width: "40%",
                        fontSize: 7,
                        padding: 5,
                      }}
                    >
                      Nonconformance Points
                    </Text>
                  </View>
                )}
              {/* Table Rows */}
              {auditData &&
                auditData["scoringDetails"] &&
                auditData["scoringDetails"]["executiveSummaryCertification"] &&
                auditData["scoringDetails"]["executiveSummaryCertification"]
                  .length !== 0 &&
                auditData["scoringDetails"][
                  "executiveSummaryCertification"
                ].map((row, index) => (
                  <View
                    key={index}
                    style={{
                      flexDirection: "row",
                      borderBottom:
                        index !==
                          (auditData &&
                            auditData["scoringDetails"] &&
                            auditData["scoringDetails"] &&
                            auditData["scoringDetails"][
                              "executiveSummaryCertification"
                            ].length - 1)
                          ? "1px solid black"
                          : "none", // Last row should not have a border
                    }}
                  >
                    <Text
                      style={{
                        width: "30%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      {row.category}
                    </Text>
                    <Text
                      style={{
                        width: "30%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      {row.noOfNonCon}
                    </Text>

                    <Text style={{ width: "40%", fontSize: 7, padding: 5 }}>
                      {row.nonConPoints}
                    </Text>
                  </View>
                ))}
            </View>
          </View>

          {/* Executive Summary*/}
          <View>
            {/* QMS Results Table */}
            <View
              style={{
                border: "1px solid black",
                width: "100%",
                marginBottom: 20,
              }}
            >
              {/* Table Header */}

              {/* Table Rows */}
              {auditData &&
                auditData["scoringDetails"] &&
                auditData["scoringDetails"] &&
                auditData["scoringDetails"]["executiveSummary"].map(
                  (row, index) => (
                    <View
                      key={index}
                      style={{
                        flexDirection: "row",
                        borderBottom:
                          index !==
                            (auditData &&
                              auditData["scoringDetails"] &&
                              auditData["scoringDetails"] &&
                              auditData["scoringDetails"]["executiveSummary"]
                                .length - 1)
                            ? "1px solid black"
                            : "none", // Last row should not have a border
                      }}
                    >
                      <View
                        style={{
                          width: "60%",
                          fontSize: 7,
                          borderRight: "1px solid black",
                          padding: 5,
                        }}
                      >
                        <Text
                          style={{
                            width: "100%",
                            fontSize: 7,
                            textAlign: "left",
                            padding: 5,
                          }}
                        >
                          {row.label}
                        </Text>

                        {row.category === "FSSCCertification?" && (
                          <Text
                            style={{
                              width: "100%",
                              fontSize: 7,
                              textAlign: "left",
                              padding: 5,
                              color: "red",
                            }}
                          >
                            {row.category === "FSSCCertification?"
                              ? "This selection is a recommendation based on the current outcome subject to technical review and is not final."
                              : ""}
                          </Text>
                        )}
                      </View>

                      <View
                        style={{
                          // alignItems: "center", // Centers horizontally
                          justifyContent: "center", // Centers vertically
                          width: "40%",
                          textAlign: "left",
                          padding: 5,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 7,
                          }}
                        >
                          {row.number}
                        </Text>
                      </View>
                    </View>
                  )
                )}
            </View>
          </View>

          {/* Audit Conclusion */}
          <View>
            {/* QMS Results Table */}
            <View
              style={{
                border: "1px solid black",
                width: "100%",
                marginBottom: 20,
              }}
            >
              {/* Table Header */}
              <View
                style={{
                  flexDirection: "row",
                  backgroundColor: "#0000a0",
                }}
              >
                <Text
                  style={{
                    color: "white",
                    width: "100%",
                    fontSize: 7,
                    padding: 5,
                    textAlign: "center",
                  }}
                >
                  Audit Conclusion
                </Text>
              </View>

              {/* Table Rows */}
              {auditData &&
                auditData["scoringDetails"] &&
                auditData["scoringDetails"] &&
                auditData["scoringDetails"]["auditConclusion"].map(
                  (row, index) => (
                    <View
                      key={index}
                      style={{
                        flexDirection: "row",
                        borderBottomWidth:
                          index !==
                            auditData["scoringDetails"]["auditConclusion"]
                              ?.length -
                            1
                            ? 1
                            : 0,
                        borderBottomColor: "black",
                        borderBottomStyle: "solid",
                      }}
                    >
                      {/* Left Column */}
                      <View
                        style={{
                          width: "60%",
                          borderRightWidth: 1,
                          borderRightColor: "black",
                          borderRightStyle: "solid",
                          padding: 5,
                          alignItems: "center", // Centers horizontally
                          justifyContent: "center", // Centers vertically
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 7,
                            textAlign: "center",
                          }}
                        >
                          {row.label}
                        </Text>
                      </View>

                      {/* Right Column */}
                      <View
                        style={{
                          width: "40%",
                          padding: 5,
                        }}
                      >
                        {row &&
                          row.category &&
                          row.category !== 0 &&
                          row.category.map((item, index) => (
                            <View
                              style={{
                                flexDirection: "row",
                                alignItems: "center",
                                marginBottom: 10,
                              }}
                            >
                              <Svg width={8} height={8} viewBox="0 0 24 24">
                                <Path
                                  d="M3 3h18v18H3z"
                                  stroke="black"
                                  strokeWidth="1"
                                  fill={
                                    item.status === true ? "#0000a0" : "none"
                                  }
                                />
                              </Svg>
                              <Text style={{ fontSize: 7, marginLeft: 5 }}>
                                {item.name}
                              </Text>
                            </View>
                          ))}
                      </View>
                    </View>
                  )
                )}
            </View>
          </View>

          <View>
            {/* QMS Results Table */}
            <View
              style={{
                border: "1px solid black",
                width: "100%",
                marginBottom: 20,
              }}
            >
              {/* Table Header */}

              {/* Table Rows */}
              {auditData &&
                auditData["scoringDetails"] &&
                auditData["scoringDetails"] &&
                auditData["scoringDetails"]["areaOfStrAndOps"].map(
                  (row, index) => (
                    <View
                      key={index}
                      style={{
                        flexDirection: "row",
                        borderBottom:
                          index !==
                            (auditData &&
                              auditData["scoringDetails"] &&
                              auditData["scoringDetails"] &&
                              auditData["scoringDetails"]["areaOfStrAndOps"]
                                .length - 1)
                            ? "1px solid black"
                            : "none", // Last row should not have a border
                      }}
                    >
                      <View
                        style={{
                          width: "30%",
                          borderRightWidth: 1,
                          borderRightColor: "black",
                          borderRightStyle: "solid",
                          padding: 2,
                          alignItems: "center", // Centers horizontally
                          justifyContent: "center", // Centers vertically
                        }}
                      >
                        <Text
                          style={{
                            width: "100%",
                            fontSize: 7,
                            textAlign: "left",
                            padding: 2,
                            fontWeight: "700",
                          }}
                        >
                          {row.label}
                        </Text>

                        <Text
                          style={{
                            width: "100%",
                            fontSize: 7,
                            textAlign: "left",
                            padding: 2,
                          }}
                        >
                          {row.desL}
                        </Text>
                      </View>

                      <View
                        style={{
                          width: "70%",

                          padding: 2,
                          // alignItems: "center", // Centers horizontally
                          justifyContent: "center", // Centers vertically
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 7,
                            textAlign: "left",
                          }}
                        >
                          {row.response || "Not Available"}
                        </Text>
                      </View>
                    </View>
                  )
                )}
            </View>
          </View>
        </View>
        <View>
          {/* Executive Summary*/}
          <View>
            <View style={{ marginBottom: 20 }}>
              <Text
                style={{
                  fontSize: 14,
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                Nonconformance Log
              </Text>
            </View>

            {/* QMS Results Table */}
            <View
              style={{
                border: "1px solid black",
                width: "100%",
                marginBottom: 20,
              }}
            >
              {/* Table Header */}
              <View
                style={{
                  flexDirection: "row",
                  backgroundColor: "#0000a0",
                }}
              >
                {[
                  {
                    name: "Nonconformance Number",
                    width: "10%",
                  },
                  {
                    name: "Standard or Technical Specifications",
                    width: "15%",
                  },
                  {
                    name: "Requirement Reference",
                    width: "10%",
                  },
                  {
                    name: "Short Description",
                    width: "14%",
                  },
                  {
                    name: "Evidence of Nonconformance",
                    width: "40%",
                  },
                  {
                    name: "Nonconformance Rating",
                    width: "8%",
                  },
                  {
                    name: "Nonconformance Status",
                    width: "8%",
                  },
                ].map((item) => {
                  return (
                    <Text
                      style={{
                        color: "white",
                        width: `${item.width}`,
                        borderRight: "1px solid white",
                        fontSize: 6,
                        padding: 5,
                      }}
                    >
                      {item.name}
                    </Text>
                  );
                })}
                {auditData?.auditDetails?.AuditDetails?.find(
                  (item) => item.label === "Version"
                )?.response === 2 && (
                    <Text
                      style={{
                        color: "white",
                        width: "8%",
                        borderRight: "1px solid white",
                        fontSize: 6,
                        padding: 5,
                      }}
                    >
                      Evidence Of Correction
                    </Text>
                  )}
              </View>

              {/* Table Rows */}
              {auditData &&
                auditData["protocolDetails"] &&
                auditData["protocolDetails"]["nonconformanceLog"].map(
                  (row, index) => (
                    <View
                      key={index}
                      style={{
                        flexDirection: "row",
                        borderBottom:
                          index !==
                            (auditData &&
                              auditData["protocolDetails"] &&
                              auditData["protocolDetails"]["nonconformanceLog"]
                                .length - 1)
                            ? "1px solid black"
                            : "none", // Last row should not have a border
                      }}
                    >
                      <Text
                        style={{
                          width: "10%",
                          fontSize: 6,
                          textAlign: "left",
                          borderRight: "1px solid black",
                          padding: 5,
                        }}
                      >
                        {row.number}
                      </Text>
                      <Text
                        style={{
                          width: "15%",
                          fontSize: 6,
                          textAlign: "left",
                          borderRight: "1px solid black",
                          padding: 5,
                        }}
                      >
                        {row.standardOrTechnicalSpecification || "N/A"}
                      </Text>

                      <Text
                        style={{
                          width: "10%",
                          fontSize: 6,
                          textAlign: "left",
                          borderRight: "1px solid black",
                          padding: 5,
                        }}
                      >
                        {row.RequirementReference || "N/A"}
                      </Text>

                      <Text
                        style={{
                          width: "14%",
                          fontSize: 6,
                          textAlign: "left",
                          borderRight: "1px solid black",
                          padding: 5,
                        }}
                      >
                        {row.detailsOfNonconformity || "N/A"}
                      </Text>
                      <Text
                        style={{
                          width: "40%",
                          fontSize: 6,
                          textAlign: "left",
                          borderRight: "1px solid black",
                          padding: 5,
                        }}
                      >
                        {row.nonConformanceShortDescription ||
                          row.evidenceOfNonconformity ||
                          "N/A"}
                      </Text>
                      <Text
                        style={{
                          width: "8%",
                          fontSize: 6,
                          textAlign: "left",
                          borderRight: "1px solid black",

                          padding: 5,
                        }}
                      >
                        {row.nonconformityRating || "N/A"}
                      </Text>
                      <Text
                        style={{
                          width: "8%",
                          fontSize: 6,
                          textAlign: "left",
                          borderRight: "1px solid black",

                          padding: 5,
                        }}
                      >
                        {row.nonConformanceStatus || "N/A"}
                      </Text>
                      {auditData?.auditDetails?.AuditDetails?.find(
                        (item) => item.label === "Version"
                      )?.response === 2 && (
                          <Text
                            style={{
                              width: "8%",
                              fontSize: 6,
                              textAlign: "left",
                              padding: 5,
                            }}
                          >
                            {row.evidenceOfCorrection || "N/A"}
                          </Text>
                        )}
                    </View>
                  )
                )}
            </View>

            <View
              style={{
                border:
                  auditData["protocolDetails"] &&
                    auditData["protocolDetails"]["notCapturedFssc"] &&
                    auditData["protocolDetails"]["notCapturedFssc"].length !== 0
                    ? "1px solid black"
                    : "",
                width: "100%",
                marginBottom: 20,
              }}
            >
              {/* Table Header */}

              {/* Table Rows */}
              {auditData &&
                auditData["protocolDetails"] &&
                auditData["protocolDetails"]["notCapturedFssc"] &&
                auditData["protocolDetails"]["notCapturedFssc"].length !==
                0 && (
                  <View>
                    {(() => {
                      let columnOrder = [
                        { name: "Number (#)", width: "10%" },
                        {
                          name: "Standard or Technical Specifications",
                          width: "15%",
                        },
                        { name: "Requirement Reference", width: "10%" },
                        { name: "Details of Nonconformity", width: "14%" },
                        { name: "Evidence of Non-conformity", width: "40%" },
                        { name: "Nonconformity Rating", width: "8%" },
                        { name: "NonConformance Status", width: "8%" },
                      ];

                      const isVersion2 =
                        auditData?.auditDetails?.AuditDetails?.find(
                          (item) => item.label === "Version"
                        )?.response === 2;

                      if (isVersion2) {
                        columnOrder.push({
                          name: "Evidence Of Correction",
                          width: "8%",
                        });
                      }

                      const existingColumns = Object.keys(
                        auditData?.protocolDetails?.notCapturedFssc?.[0] || {}
                      );

                      // Sorted columns will prioritize columnOrder, and then add extras
                      const sortedColumns = [
                        ...columnOrder.map((col) => col.name),
                        ...existingColumns.filter(
                          (col) => !columnOrder.map((c) => c.name).includes(col)
                        ),
                      ];

                      return (
                        <>
                          {/* Table Header */}
                          <View
                            style={{
                              flexDirection: "row",
                              backgroundColor: "#0000a0",
                            }}
                          >
                            {sortedColumns.map((colName, index) => {
                              const col = columnOrder.find(
                                (c) => c.name === colName
                              );
                              return (
                                <Text
                                  key={index}
                                  style={{
                                    color: "white",
                                    width: col?.width || "8%",
                                    borderRightWidth: 1,
                                    borderRightColor: "white",
                                    fontSize: 6,
                                    padding: 5,
                                    textAlign: "left",
                                  }}
                                >
                                  {colName}
                                </Text>
                              );
                            })}
                          </View>

                          {/* Table Rows */}
                          {auditData.protocolDetails.notCapturedFssc.map(
                            (row, rowIndex) => (
                              <View
                                key={rowIndex}
                                style={{
                                  flexDirection: "row",
                                  borderBottomWidth: 1,
                                  borderBottomColor: "black",
                                }}
                              >
                                {sortedColumns.map((colKey, colIndex) => {
                                  const col = columnOrder.find(
                                    (c) => c.name === colKey
                                  );
                                  return (
                                    <Text
                                      key={colIndex}
                                      style={{
                                        width: col?.width || "8%",
                                        textAlign: "left",
                                        borderRightWidth: 1,
                                        padding: 5,
                                        fontSize: 6,
                                      }}
                                    >
                                      {row[colKey] || "N/A"}
                                    </Text>
                                  );
                                })}
                              </View>
                            )
                          )}
                        </>
                      );
                    })()}
                  </View>
                )}

              {/* {auditData &&
                auditData["protocolDetails"] &&
                auditData["protocolDetails"]["notCapturedFssc"] &&
                auditData["protocolDetails"]["notCapturedFssc"].length ===
                  0 && (
                  <>
                    <Text
                      style={{
                        width: "100%",
                        fontSize: 7,
                        padding: 5,
                        textAlign: "center",
                      }}
                    >
                      No data available for not captured Fssc
                    </Text>
                  </>
                )} */}
            </View>
          </View>
        </View>
        {/* Audit Details- Conformance Evidence */}
        <View style={{ alignContent: "center", alignItems: "center" }}>
          <View>
            {/* Scoping */}
            <View
              style={{
                border: "1px solid black",
                width: "100%",
                marginBottom: 0,
                borderBottom: "none",
              }}
            >
              {/* Table Header */}
              <View
                style={{
                  flexDirection: "row",
                  backgroundColor: "#0000a0",
                }}
              >
                <Text
                  style={{
                    color: "white",
                    width: "100%",
                    fontSize: 7,
                    padding: 5,
                    textAlign: "center",
                  }}
                >
                  Scoping
                </Text>
              </View>

              {/* Table Rows */}
              {auditData && auditData["protocolDetails"] && (
                <>
                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Objective: Define the scope and boundaries of the Quality
                      Management System (QMS) audit based on the organization’s
                      context, products/services, and locations
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["scopingObjective"] ||
                        "Not Available"}
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "none", // Last row should not have a border
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Were there any changes to scoping?.
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["scopingKeyAuditPoints"] ||
                        "Not Available"}
                    </Text>
                  </View>
                </>
              )}
            </View>

            {/* Leadership */}

            <View
              style={{
                border: "1px solid black",
                width: "100%",
                marginBottom: 0,
              }}
            >
              {/* Table Header */}
              <View
                style={{
                  flexDirection: "row",
                  backgroundColor: "#0000a0",
                }}
              >
                <Text
                  style={{
                    color: "white",
                    width: "100%",
                    fontSize: 7,
                    padding: 5,
                    textAlign: "center",
                  }}
                >
                  Leadership
                </Text>
              </View>

              {auditData && auditData["protocolDetails"] && (
                <>
                  {/* Objective  */}
                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black",
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Objective: Define the scope and boundaries of the Quality
                      Management System (QMS) audit based on the organization’s
                      context, products/services, and locations.
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["leadershipObjective"] ||
                        "Not Available"}
                    </Text>
                  </View>
                  {/* Policy  */}
                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black",
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      The Mars Quality Policy
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"][
                        "leadershipMarsQualityPolicy"
                      ] || "Not Available"}
                    </Text>
                  </View>

                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black",
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Leadership Accountabilities and commitment
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"][
                        "leadershipAccountabilities"
                      ] || "Not Available"}
                    </Text>
                  </View>

                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black",
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      QMS Objectives linked to strategic direction
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["leadershipQMSObjective"] ||
                        "Not Available"}
                    </Text>
                  </View>

                  <View
                    style={{
                      flexDirection: "row",
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Leadership engagement in process effectiveness
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["leadershipEngagement"] ||
                        "Not Available"}
                    </Text>
                  </View>
                </>
              )}
            </View>
          </View>
        </View>
        <View style={{ alignContent: "center", alignItems: "center" }}>
          {/* Plan Summary*/}

          <>
            {/* Plan */}
            <View
              style={{
                border: "1px solid black",
                width: "100%",
                marginBottom: 0,
                borderBottom: "none",
              }}
            >
              {/* Table Header */}
              <View
                style={{
                  flexDirection: "row",
                  backgroundColor: "#0000a0",
                }}
              >
                <Text
                  style={{
                    color: "white",
                    width: "100%",
                    fontSize: 7,
                    padding: 5,
                    textAlign: "center",
                  }}
                >
                  Plan
                </Text>
              </View>

              {/* Table Rows */}
              {auditData && auditData["protocolDetails"] && (
                <>
                  {/* Plan Objective -1 - 8 */}

                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Plan Objective
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["planObjective"] ||
                        "Not Available"}
                    </Text>
                  </View>

                  {/* {Quality objectives (SMART: Specific, Measurable, Achievable, Relevant, Time-bound)} -2- 09 */}

                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Quality objectives (SMART: Specific, Measurable,
                      Achievable, Relevant, Time-bound)
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["planQualityObjectives"] ||
                        "Not Available"}
                    </Text>
                  </View>

                  {/* Process identification and management -3 -10 */}
                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                    wrap
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Process identification and management
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                      wrap
                    >
                      {auditData["protocolDetails"][
                        "planProcessIdentification"
                      ] || "Not Available"}
                    </Text>
                  </View>

                  {/* Quality risk management -4- 11 */}

                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                    wrap
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Quality risk management
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"][
                        "planQualityRiskManagement"
                      ] || "Not Available"}
                    </Text>
                  </View>

                  {/* Change management -5 -12	 */}
                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Change management
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["planChangeManagement"] ||
                        "Not Available"}
                    </Text>
                  </View>

                  {/* mergers & Acquisitions (M&A) new business integration 6 - 13*/}

                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Mergers & Acquisitions (M&A) new business integration
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["planMergers"] ||
                        "Not Available"}
                    </Text>
                  </View>

                  {/* Resources and infrastructure planning 7 -14 */}

                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black",
                      // Last row should not have a border
                    }}
                    wrap
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Resources and infrastructure planning
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["planResources"] ||
                        "Not Available"}
                    </Text>
                  </View>
                </>
              )}
            </View>

            {/* Do */}

            <View
              style={{
                border: "1px solid black",
                width: "100%",
                marginBottom: 0,
              }}
            >
              {/* Table Header */}
              <View
                style={{
                  flexDirection: "row",
                  backgroundColor: "#0000a0",
                }}
              >
                <Text
                  style={{
                    color: "white",
                    width: "100%",
                    fontSize: 7,
                    padding: 5,
                    textAlign: "center",
                  }}
                >
                  Do
                </Text>
              </View>

              {/* Table Rows */}

              {/* Table Rows */}
              {auditData && auditData["protocolDetails"] && (
                <>
                  {/* Do Objective 1 */}

                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Do Objective
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["doObjective"] ||
                        "Not Available"}
                    </Text>
                  </View>

                  {/* Innovation and Advancement	 */}

                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black",
                      // Last row should not have a border
                    }}
                    wrap
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Innovation and Advancement
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["doInnovation"] ||
                        "Not Available"}
                    </Text>
                  </View>

                  {/* Creation of products and provision of services 	 */}

                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Creation of products and provision of services
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["doCreationOfProducts"] ||
                        "Not Available"}
                    </Text>
                  </View>

                  {/* Identification and Traceability 	 */}

                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                    wrap
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Identification and Traceability
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["doIdentification"] ||
                        "Not Available"}
                    </Text>
                  </View>

                  {/* doPurchasing 20	 */}

                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                    wrap
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Do Purchasing
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["doPurchasing"] ||
                        "Not Available"}
                    </Text>
                  </View>

                  {/* Control of non-conforming 21 	 */}

                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                    wrap
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Control of non-conforming products and services
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                      wrap
                    >
                      {auditData["protocolDetails"]["doControl"] ||
                        "Not Available"}
                    </Text>
                  </View>

                  {/* Consumer/Customer/Client Feedback	 */}

                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Consumer/Customer/Client Feedback
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["doConsumer"] ||
                        "Not Available"}
                    </Text>
                  </View>

                  {/* doOrganizationalDesign	 */}

                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Do Organizational Design
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["doOrganizationalDesign"] ||
                        "Not Available"}
                    </Text>
                  </View>

                  {/* doOrganizationalKnowledge	 */}

                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Do Organizational Knowledge
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"][
                        "doOrganizationalKnowledge"
                      ] || "Not Available"}
                    </Text>
                  </View>

                  {/* Communication	 */}

                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Communication
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["doCommunication"] ||
                        "Not Available"}
                    </Text>
                  </View>

                  {/* doWorkEnvironment	 */}

                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Do Work Environment
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["doWorkEnvironment"] ||
                        "Not Available"}
                    </Text>
                  </View>

                  {/* Calibration and maintenance of manufacturing, */}

                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Calibration and maintenance of manufacturing, laboratory
                      and diagnostic equipment
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["doCalibration"] ||
                        "Not Available"}
                    </Text>
                  </View>
                </>
              )}
            </View>

            {/* Check */}

            <View
              style={{
                border: "1px solid black",
                width: "100%",
                marginBottom: 0,
              }}
            >
              {/* Table Header */}
              <View
                style={{
                  flexDirection: "row",
                  backgroundColor: "#0000a0",
                }}
              >
                <Text
                  style={{
                    color: "white",
                    width: "100%",
                    fontSize: 7,
                    padding: 5,
                    textAlign: "center",
                  }}
                >
                  Check
                </Text>
              </View>

              {/* Table Rows */}
              {auditData && auditData["protocolDetails"] && (
                <>
                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Check Objective
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["checkObjective"] ||
                        "Not Available"}
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Audit (frequency, effectiveness, documentation)
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["checkAudit"] ||
                        "Not Available"}
                    </Text>
                  </View>

                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Customer satisfaction monitoring (consider internal and
                      external customers)
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["checkCustomer"] ||
                        "Not Available"}
                    </Text>
                  </View>

                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Key performance indicators (KPIs) and data analysis
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["checkKeyPerformance"] ||
                        "Not Available"}
                    </Text>
                  </View>

                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                    wrap
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Mars QMS Review
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                      wrap
                    >
                      {auditData["protocolDetails"]["checkMarsQmsReview"] ||
                        "Not Available"}
                    </Text>
                  </View>
                </>
              )}
            </View>

            {/* Act */}

            <View
              style={{
                border: "1px solid black",
                width: "100%",
                marginBottom: 0,
                borderBottom: "none",
              }}
            >
              {/* Table Header */}
              <View
                style={{
                  flexDirection: "row",
                  backgroundColor: "#0000a0",
                }}
              >
                <Text
                  style={{
                    color: "white",
                    width: "100%",
                    fontSize: 7,
                    padding: 5,
                    textAlign: "center",
                  }}
                >
                  Act
                </Text>
              </View>

              {/* Table Rows */}
              {auditData && auditData["protocolDetails"] && (
                <>
                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Act Objective
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["actObjective"] ||
                        "Not Available"}
                    </Text>
                  </View>

                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Improvement
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["actImprovement"] ||
                        "Not Available"}
                    </Text>
                  </View>

                  <View
                    style={{
                      flexDirection: "row",
                      borderBottom: "1px solid black", // Last row should not have a border
                    }}
                  >
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        borderRight: "1px solid black",
                        padding: 5,
                      }}
                    >
                      Effectiveness of corrective actions taken
                    </Text>
                    <Text
                      style={{
                        width: "50%",
                        fontSize: 7,
                        textAlign: "left",
                        padding: 5,
                      }}
                    >
                      {auditData["protocolDetails"]["actEffectiveness"] ||
                        "Not Available"}
                    </Text>
                  </View>
                </>
              )}
            </View>

            {/* Specific Requirements  */}

            {/* Focus Areas – Special Attention   */}

            {auditData &&
              auditData["protocolDetails"] &&
              auditData["protocolDetails"]["focusArea"] &&
              auditData["protocolDetails"]["focusArea"].length !== 0 && (
                <View
                  style={{
                    border: "1px solid black",
                    width: "100%",
                    marginBottom: 20,
                  }}
                >
                  {/* Table Header */}
                  <View
                    style={{
                      flexDirection: "row",
                      backgroundColor: "#0000a0",
                    }}
                  >
                    <Text
                      style={{
                        color: "white",
                        width: "100%",
                        fontSize: 7,
                        padding: 5,
                        textAlign: "center",
                      }}
                    >
                      Focus Areas – Special Attention
                    </Text>
                  </View>

                  {/* Table Rows */}
                  {auditData &&
                    auditData["protocolDetails"] &&
                    auditData["protocolDetails"]["focusArea"] &&
                    auditData["protocolDetails"]["focusArea"].length !== 0 &&
                    auditData["protocolDetails"]["focusArea"].map((row, index) => (
                      <View
                        key={index}
                        style={{
                          flexDirection: "row",
                          borderBottom:
                            index !==
                              (auditData &&
                                auditData["protocolDetails"] &&
                                auditData["protocolDetails"]["focusArea"] &&
                                auditData["protocolDetails"]["focusArea"].length !==
                                0 &&
                                auditData["protocolDetails"]["focusArea"].length - 1)
                              ? "1px solid black"
                              : "none", // Last row should not have a border
                        }}
                      >
                        <Text
                          style={{
                            width: "50%",
                            fontSize: 7,
                            textAlign: "left",
                            borderRight: "1px solid black",
                            padding: 5,
                          }}
                        >
                          {row.focusArea}
                        </Text>
                        <Text
                          style={{
                            width: "50%",
                            fontSize: 7,
                            textAlign: "left",
                            padding: 5,
                          }}
                        >
                          {row.response}
                        </Text>
                      </View>
                    ))}


                </View>
              )}

          </>
        </View>
        <View style={{ minHeight: 10 }} /> {/* 👈 Forces a break */}
        <View
          wrap={false}
          style={{ alignContent: "center", alignItems: "center" }}
        >
          <View>
            {/* QMS Results Table */}
            <View
              style={{
                width: "100%",
                marginBottom: 10,
              }}
            >
              {/* Table Header */}
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "center",
                  marginBottom: 20,
                }}
              >
                <Text
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  Unit Audit Information – Unit Profile
                </Text>
              </View>

              <View
                style={{
                  border: "1px solid black",
                  width: "100%",
                  marginBottom: 20,
                }}
              >
                {/* Table Header */}
                <View
                  style={{
                    flexDirection: "row",
                    backgroundColor: "#0000a0",
                    justifyContent: "center",
                  }}
                >
                  <Text
                    style={{
                      color: "white",
                      width: "100%",
                      fontSize: 7,
                      padding: 5,
                      textAlign: "center",
                    }}
                  >
                    Unit Details
                  </Text>
                </View>

                {/* Table Rows */}
                {auditData &&
                  auditData["unitDetails"] &&
                  auditData["unitDetails"]["unitDetails"].map((row, index) => (
                    <View
                      key={index}
                      style={{
                        flexDirection: "row",
                        borderBottom:
                          index !==
                            (auditData &&
                              auditData["unitDetails"] &&
                              auditData["unitDetails"]["unitDetails"].length - 1)
                            ? "1px solid black"
                            : "none", // Last row should not have a border
                      }}
                    >
                      <Text
                        style={{
                          width: "50%",
                          fontSize: 7,
                          textAlign: "left",
                          borderRight: "1px solid black",
                          padding: 5,
                        }}
                      >
                        {row.label}
                      </Text>
                      <Text
                        style={{
                          width: "50%",
                          fontSize: 7,
                          textAlign: "left",
                          padding: 5,
                        }}
                      >
                        {row.response}
                      </Text>
                    </View>
                  ))}
              </View>
            </View>
          </View>
        </View>
        <View style={{ minHeight: 10 }} /> 👈 Forces a break
        <View
          wrap={false}
          style={{
            alignContent: "center",
            alignItems: "center",
            break: "before",
          }}
        >
          <View>
            <View
              style={{
                width: "100%",
                marginBottom: 0,
              }}
            >
              {/* Table Header */}
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "center",
                  marginBottom: 10,
                }}
              >
                <Text
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  Unit Audit Information – Audit Details
                </Text>
              </View>

              <View
                style={{
                  border: "1px solid black",
                  width: "100%",
                  marginBottom: 20,
                }}
              >
                {/* Table Header */}
                <View
                  style={{
                    flexDirection: "row",
                    backgroundColor: "#0000a0",
                    justifyContent: "center",
                  }}
                >
                  <Text
                    style={{
                      color: "white",
                      width: "100%",
                      fontSize: 7,
                      padding: 5,
                      textAlign: "center",
                    }}
                  >
                    Audit Details
                  </Text>
                </View>

                {/* Table Rows */}
                {auditData &&
                  auditData["auditDetails"] &&
                  auditData["auditDetails"]["AuditDetails"]
                    .filter((item) => item.label !== "Audit Objective")
                    .filter((item) => {
                      // Exclude "Audit Focus Areas" if its response is an empty array
                      if (
                        item.label === "Audit Focus Areas" &&
                        Array.isArray(item.response) &&
                        item.response.length === 0
                      ) {
                        return false;
                      }
                      return true;
                    })
                    .map((row, index) => (
                      <View
                        key={index}
                        style={{
                          flexDirection: "row",
                          borderBottom:
                            index !==
                              (auditData &&
                                auditData["auditDetails"] &&
                                auditData["auditDetails"]["AuditDetails"].length -
                                1)
                              ? "1px solid black"
                              : "none", // Last row should not have a border
                        }}
                      >
                        <Text
                          style={{
                            width: "50%",
                            fontSize: 7,
                            textAlign: "left",
                            borderRight: "1px solid black",
                            padding: 5,
                          }}
                        >
                          {row.label}
                        </Text>
                        <Text
                          style={{
                            width: "50%",
                            fontSize: 7,
                            textAlign: "left",
                            padding: 5,
                            textTransform: "capitalize",
                          }}
                        >
                          {row.label === "Version"
                            ? `${auditData?.version === "V1" ? "1" : "2" ?? "N/A"
                            }`
                            : row.label.includes("Date")
                              ? formatDate(row.response ?? row.value)
                              : row.response === true
                                ? "Yes"
                                : row.response === false
                                  ? "No"
                                  : row.response ?? row.value ?? "N/A"}
                        </Text>
                      </View>
                    ))}
              </View>
            </View>

            <View
              style={{
                width: "100%",
                marginBottom: 10,
              }}
            >
              {/* Table Header */}
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "center",
                  marginBottom: 10,
                }}
              >
                <Text
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  Audit Team
                </Text>
              </View>

              <View
                style={{
                  border: "1px solid black",
                  width: "100%",
                  marginBottom: 20,
                }}
              >
                {/* Table Header */}
                <View
                  style={{
                    flexDirection: "row",
                    backgroundColor: "#0000a0",
                    justifyContent: "center",
                  }}
                >
                  <Text
                    style={{
                      color: "white",
                      width: "50%",
                      fontSize: 7,
                      padding: 5,
                      textAlign: "left",
                    }}
                  >
                    Field
                  </Text>

                  <Text
                    style={{
                      color: "white",
                      width: "50%",
                      fontSize: 7,
                      padding: 5,
                      textAlign: "left",
                    }}
                  >
                    Response
                  </Text>
                </View>

                {/* Table Rows */}
                {auditData &&
                  auditData["auditDetails"] &&
                  auditData["auditDetails"]?.auditTeam.map((row, index) => (
                    <View
                      key={index}
                      style={{
                        flexDirection: "row",
                        borderBottom:
                          index !==
                            (auditData &&
                              auditData["auditDetails"] &&
                              auditData["auditDetails"]?.auditTeam.length - 1)
                            ? "1px solid black"
                            : "none", // Last row should not have a border
                      }}
                    >
                      <Text
                        style={{
                          width: "50%",
                          fontSize: 7,
                          textAlign: "left",
                          borderRight: "1px solid black",
                          padding: 5,
                        }}
                      >
                        {row.label}
                      </Text>
                      <Text
                        style={{
                          width: "50%",
                          fontSize: 7,
                          textAlign: "left",
                          padding: 5,
                        }}
                      >
                        {typeof row.response === "object"
                          ? Object.entries(row.response)
                            .map(([key, value]) => `${key}: ${value}`)
                            .join(", ")
                          : row.response}
                      </Text>
                    </View>
                  ))}
              </View>
            </View>
          </View>
        </View>
        <View style={{ minHeight: 10 }} /> 👈 Forces a break
        <View
          wrap={false}
          style={{
            alignContent: "center",
            alignItems: "center",
            marginTop: "10px",
          }}
        >
          <>
            <View
              style={{
                width: "100%",
                marginBottom: 30,
                marginTop: 30,
              }}
            >
              {/* Table Header */}
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "center",
                  marginBottom: 10,
                  backgroundColor: "#04047E",
                  height: "80px",
                  alignContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Text
                  style={{
                    fontSize: 20,
                    fontWeight: "bold",
                    textAlign: "center",
                    width: "50%",
                    color: "white",
                    textTransform: "uppercase",
                    padding: 15,
                  }}
                >
                  Conformance Level Determination
                </Text>

                <View
                  style={{
                    width: "50%",
                    backgroundColor: "#060648",
                    height: "100%",
                    alignItems: "center",
                    alignContent: "center",
                    justifyContent: "center",
                  }}
                >
                  <Text
                    style={{
                      fontSize: 10,
                      fontWeight: "bold",
                      textAlign: "center",
                      width: "100%",
                      color: "white",
                      padding: 20,
                    }}
                  >
                    See Mars QMS Second Party Audit Procedure for full list of
                    criteria and thresholds
                  </Text>
                </View>
              </View>

              <View style={styles1.table}>
                {/* Header Row */}
                <View style={styles1.row}>
                  <Text style={[styles1.headerCell, { width: "50%" }]}>
                    Conformance Level
                  </Text>
                  <Text style={[styles1.headerCell, { width: "50%" }]}>
                    Nonconformance Points
                  </Text>
                </View>

                {/* Compliant Row */}
                <View style={[styles1.row, styles1.compliant]}>
                  <Text style={[styles1.cell, { width: "50%" }]}>
                    COMPLIANT
                  </Text>
                  <View style={{ width: "25%" }}>
                    <Text
                      style={[
                        styles1.headerCell,
                        styles1.darkHeader,
                        { width: "100%" },
                      ]}
                    >
                      FACTORIES
                    </Text>

                    <Text
                      style={[
                        styles1.cell,
                        styles1.compliant,
                        styles1.factoriesValue,
                        { width: "100%" },
                      ]}
                    >
                      {"<="} 34
                    </Text>
                  </View>

                  <View style={{ width: "25%" }}>
                    <Text
                      style={[
                        styles1.headerCell,
                        styles1.darkHeader,
                        { width: "100%" },
                      ]}
                    >
                      OTHER UNITS
                    </Text>
                    <Text
                      style={[
                        styles1.cell,
                        styles1.compliant,
                        styles1.factoriesValue,
                        { width: "100%" },
                      ]}
                    >
                      {"<="} 18
                    </Text>
                  </View>
                </View>

                {/* Needs Improvement Row */}
                <View style={[styles1.row, styles1.needsImprovement]}>
                  <Text
                    style={[
                      styles1.cell,
                      {
                        width: "50%",
                        alignItems: "center",
                        justifyContent: "center",
                      },
                    ]}
                  >
                    NEEDS IMPROVEMENT
                  </Text>
                  <View style={{ width: "25%" }}>
                    <Text
                      style={[
                        styles1.headerCell,
                        styles1.darkHeader,
                        { width: "100%" },
                      ]}
                    >
                      FACTORIES
                    </Text>

                    <Text
                      style={[
                        styles1.cell,
                        styles1.needsImprovement,
                        styles1.factoriesValue,
                        { width: "100%" },
                      ]}
                    >
                      {">="} 35
                    </Text>
                  </View>

                  <View style={{ width: "25%" }}>
                    <Text
                      style={[
                        styles1.headerCell,
                        styles1.darkHeader,
                        { width: "100%" },
                      ]}
                    >
                      OTHER UNITS
                    </Text>
                    <Text
                      style={[
                        styles1.cell,
                        styles1.needsImprovement,
                        styles1.factoriesValue,
                        { width: "100%" },
                      ]}
                    >
                      {">="} 19
                    </Text>
                  </View>
                </View>

                {/* At Risk Row */}
                <View style={[styles1.row, styles1.atRisk]}>
                  <Text style={[styles1.cell, { width: "50%" }]}>AT RISK</Text>
                  <View style={{ width: "25%" }}>
                    <Text
                      style={[
                        styles1.headerCell,
                        styles1.darkHeader,
                        { width: "100%" },
                      ]}
                    >
                      FACTORIES
                    </Text>

                    <Text
                      style={[
                        styles1.cell,
                        styles1.atRisk,
                        styles1.factoriesValue,
                        { width: "100%" },
                      ]}
                    >
                      {">="} 40
                    </Text>
                  </View>

                  <View style={{ width: "25%" }}>
                    <Text
                      style={[
                        styles1.headerCell,
                        styles1.darkHeader,
                        { width: "100%" },
                      ]}
                    >
                      OTHER UNITS
                    </Text>
                    <Text
                      style={[
                        styles1.cell,
                        styles1.atRisk,
                        styles1.factoriesValue,
                        { width: "100%" },
                      ]}
                    >
                      {">="} 22
                    </Text>
                  </View>
                </View>
              </View>
            </View>
          </>

          <>
            <View
              style={{
                width: "100%",
                marginBottom: 0,
              }}
            >
              {/* Table Header */}
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "center",
                  marginBottom: 10,
                  backgroundColor: "#04047E",
                  height: "80px",
                  alignContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Text
                  style={{
                    fontSize: 20,
                    fontWeight: "bold",
                    textAlign: "center",
                    width: "50%",
                    color: "white",
                    textTransform: "uppercase",
                    padding: 15,
                  }}
                >
                  Required Action Post Audit
                </Text>

                <View
                  style={{
                    width: "50%",
                    backgroundColor: "#060648",
                    height: "100%",
                    alignItems: "center",
                    alignContent: "center",
                    justifyContent: "center",
                  }}
                >
                  <Text
                    style={{
                      fontSize: 10,
                      fontWeight: "bold",
                      textAlign: "center",
                      width: "100%",
                      color: "white",
                      padding: 20,
                    }}
                  >
                    See Mars QMS Second Party Audit Procedure for full list of
                    criteria and thresholds
                  </Text>
                </View>
              </View>

              <View style={styles1.table}>
                {/* Header Row */}
                <View style={styles1.row}>
                  <Text
                    style={[
                      styles1.headerCell,
                      { width: "50%", textTransform: "uppercase" },
                    ]}
                  >
                    Conformance Level
                  </Text>
                  <Text
                    style={[
                      styles1.headerCell,
                      { width: "50%", textTransform: "uppercase" },
                    ]}
                  >
                    Required Actions
                  </Text>
                </View>

                {/* Compliant Row */}
                <View style={[styles1.row, styles1.compliant]}>
                  <Text style={[styles1.cell, { width: "50%" }]}>
                    COMPLIANT
                  </Text>
                  <View
                    style={{
                      width: "50%",
                      border: "1px solid #ffffff",
                      borderTop: "none",
                      borderBottom: "none",
                      padding: 5,
                    }}
                  >
                    {/* <Text style={[styles1.cell, styles1.compliant, styles1.factoriesValue, { width: "100%" }]}>

            </Text> */}
                    <View style={styles1.bulletPointContainer}>
                      <Text style={styles1.bulletPoint}>•</Text>
                      <Text style={styles1.bulletText}>
                        Action all nonconformities and continue to
                        sustain/improve performance.
                      </Text>
                    </View>
                  </View>
                </View>

                {/* Needs Improvement Row */}
                <View style={[styles1.row, styles1.needsImprovement]}>
                  <Text
                    style={[
                      styles1.cell,
                      {
                        width: "50%",
                        alignItems: "center",
                        justifyContent: "center",
                      },
                    ]}
                  >
                    NEEDS IMPROVEMENT
                  </Text>
                  <View
                    style={{
                      width: "50%",
                      border: "1px solid #ffffff",
                      borderTop: "none",
                      borderBottom: "none",
                      padding: 5,
                    }}
                  >
                    <View style={styles1.bulletPointContainer}>
                      <Text style={styles1.bulletPoint}>•</Text>
                      <Text style={styles1.bulletText}>
                        All Major Nonconformities will have a review within 28
                        days by 2nd party along with a completed Correction and
                        a Corrective Action Plan in place.
                      </Text>
                    </View>
                    <View style={styles1.bulletPointContainer}>
                      <Text style={styles1.bulletPoint}>•</Text>
                      <Text style={styles1.bulletText}>
                        The units plan to return to Compliance is to be reviewed
                        at the Parent Unit Quality Management Review.
                      </Text>
                    </View>
                    <View style={styles1.bulletPointContainer}>
                      <Text style={styles1.bulletPoint}>•</Text>
                      <Text style={styles1.bulletText}>
                        For units that received 1 Major Nonconformity and a
                        nonconformance score below 35, they can return to
                        Compliant Level in the same year.
                      </Text>
                    </View>
                  </View>
                </View>

                {/* At Risk Row */}
                <View style={[styles1.row, styles1.atRisk]}>
                  <Text style={[styles1.cell, { width: "50%" }]}>AT RISK</Text>

                  <View
                    style={{
                      width: "50%",
                      border: "1px solid #ffffff",
                      borderTop: "none",
                      borderBottom: "none",
                      padding: 5,
                    }}
                  >
                    <View style={styles1.bulletPointContainer}>
                      <Text style={styles1.bulletPoint}>•</Text>
                      <Text style={styles1.bulletText}>
                        Concession is required to continue production and/or
                        services.
                      </Text>
                    </View>
                    <View style={styles1.bulletPointContainer}>
                      <Text style={styles1.bulletPoint}>•</Text>
                      <Text style={styles1.bulletText}>
                        Unit must undergo full scope audits every 6 months until
                        achieving 3 consecutive QMS compliant results from the
                        initial audit. The unit’s At-Risk level of conformance
                        will remain until the completion of their first 6-month
                        audit. The unit’s level of conformance will be indicated
                        by the results of each 6-month audit.
                      </Text>
                    </View>
                    <View style={styles1.bulletPointContainer}>
                      <Text style={styles1.bulletPoint}>•</Text>
                      <Text style={styles1.bulletText}>
                        All Major and/or Critical Nonconformities must have a
                        review within 28 days by a 2nd party with a completed
                        Correction and a Corrective Action Plan in place.
                      </Text>
                    </View>

                    <View style={styles1.bulletPointContainer}>
                      <Text style={styles1.bulletPoint}>•</Text>
                      <Text style={styles1.bulletText}>
                        The units plan to return to Compliance is to be reviewed
                        at the Mars Inc. Quality Management Review.
                      </Text>
                    </View>
                  </View>
                </View>
              </View>
            </View>
          </>
        </View>
      </>
    </Page>
  </Document>
);

const FullScopeFullReport = ({ formid, type, version }) => {
  const [auditData, setAuditData] = useState(null);
  const [loadingPage, setloading] = useState(true);
  const [version2, setVersion2] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setloading(true);
      const url = `${process.env.REACT_APP_SERVER_URL}/super/get_forms/pdfV2/${formid}`;

      try {
        const token = await getToken();
        const response = await axios.get(url, {
          headers: {
            "oidc-token": token,
            Accept: "application/json",
          },
        });
        if (response.status === 200) {
          if (response.data?.versionInfo?.length > 1) {
            setVersion2(true);
          }
          setAuditData(response.data);
          setloading(false);
        }
      } catch (e) {
        const status = e?.response?.status;
        if (status === 401) {
          login();
        }
        if (status === 500) {
          setError(true);
          setTimeout(() => {
            setError(false);
          }, 3000);
        }
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      {loadingPage ? (
        <SkeletonTheme baseColor="#d4d4d4" highlightColor="#f5f5f5">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <div>
              <Skeleton
                style={{
                  height: "50px",
                  minWidth: "250px",
                }}
              />
            </div>
            {version === 2 && (
              <div>
                <Skeleton
                  style={{
                    height: "50px",
                    minWidth: "250px",
                  }}
                />
              </div>
            )}
          </div>
        </SkeletonTheme>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <div
            style={{
              background: "rgb(148, 177, 59)",
              height: "50px",
              minWidth: "250px",
              display: "grid",
              alignContent: "center",
              alignItems: "center",
              textAlign: "center",
              color: "#3d3d3d",
              borderRadius: "6px",
            }}
          >
            <BlobProvider
              document={<AuditPDF auditData={auditData?.version[0]} />}
            >
              {({ url, loading }) =>
                loadingPage ? (
                  <div style={{ color: "white" }}>
                    {" "}
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>{" "}
                    Generating Full Report...
                  </div>
                ) : (
                  <>
                    <a
                      style={{ color: "white", fontSize: "15px" }}
                      href={url}
                      download={`${formid}- V1 Full Report - ${type}-${new Date().getTime()}`}
                    >
                      <FaFileDownload /> Download V1 Full Report
                    </a>
                    {/* Embed the PDF in an iframe */}
                  </>
                )
              }
            </BlobProvider>
          </div>

          {version2 && (
            <div
              style={{
                background: "#74814b",
                height: "50px",
                minWidth: "250px",
                display: "grid",
                alignContent: "center",
                alignItems: "center",
                textAlign: "center",
                color: "#3d3d3d",
                borderRadius: "6px",
              }}
            >
              <BlobProvider
                document={<AuditPDF auditData={auditData?.version[1]} />}
              >
                {({ url, loading }) =>
                  loadingPage ? (
                    <div style={{ color: "white" }}>
                      {" "}
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>{" "}
                      Generating Full Report...
                    </div>
                  ) : (
                    <>
                      <a
                        style={{ color: "white", fontSize: "15px" }}
                        href={url}
                        download={`${formid}- V2 Full Report - ${type}-${new Date().getTime()}`}
                      >
                        <FaFileDownload /> Download V2 Full Report
                      </a>
                      {/* Embed the PDF in an iframe */}
                    </>
                  )
                }
              </BlobProvider>
            </div>
          )}
        </div>
      )}

      {error && (
        <Box
          sx={{
            position: "fixed",
            top: 55,
            right: 16,
            zIndex: 1300, // Ensures it appears above other content
          }}
        >
          <Alert
            severity="error"
            sx={{
              fontSize: "20px",
              width: "auto",
            }}
          >
            Something went wrong! Please try again later.
          </Alert>
        </Box>
      )}
    </>
  );
};

export default FullScopeFullReport;
